import React, { Component } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { usersActions } from '../../_actions';
import { notify } from '../common/Toster';
import Loader from '../common/Loader';
import _ from 'lodash';

class DeleteAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNumber: '',
      countryCode: '+1',
      otp: '',
      authToken: '',
      userId: '',
      errors: '',
      responseError: '',
      otpSent: false,
      loader: false,
      success: false,
      otpTimer: 0,
      canResendOTP: false
    };
    this.timerInterval = null;
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startOTPTimer = () => {
    this.setState({ otpTimer: 60, canResendOTP: false });
    
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.otpTimer > 1) {
          return { otpTimer: prevState.otpTimer - 1 };
        } else {
          clearInterval(this.timerInterval);
          return { otpTimer: 0, canResendOTP: true };
        }
      });
    }, 1000);
  };

  formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  handleResendOTP = (e) => {
    e.preventDefault();
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.setState({ otp: '', canResendOTP: false, errors: '' });
    this.handleSendOTP(e);
  };

  handleOnChange = (e) => {
    const { name, value } = e.target;
    
    // For mobile number, only allow digits and limit to 10
    if (name === 'mobileNumber') {
      const digitsOnly = value.replace(/\D/g, ''); // Remove non-digits
      const limitedValue = digitsOnly.slice(0, 10); // Limit to 10 digits
      this.setState({
        [name]: limitedValue,
        errors: '',
        responseError: ''
      });
    } else {
      this.setState({
        [name]: value,
        errors: '',
        responseError: ''
      });
    }
  };

  isMobileValid = () => {
    const { mobileNumber } = this.state;
    return mobileNumber && mobileNumber.length === 10 && /^\d+$/.test(mobileNumber);
  };

  validateMobile = () => {
    let { mobileNumber, countryCode } = this.state;
    let validate = false;

    if (_.isEmpty(mobileNumber)) {
      validate = true;
      this.setState({ errors: 'Mobile number is required.' });
    } else if (!/^\d+$/.test(mobileNumber)) {
      validate = true;
      this.setState({ errors: 'Mobile number must contain only digits.' });
    } else if (mobileNumber.length !== 10) {
      validate = true;
      this.setState({ errors: 'Mobile number must be exactly 10 digits.' });
    }

    return validate;
  };

  isOtpValid = () => {
    const { otp } = this.state;
    return otp && otp.length === 6;
  };

  validateOTP = () => {
    let { otp } = this.state;
    let validate = false;

    if (_.isEmpty(otp)) {
      validate = true;
      this.setState({ errors: 'OTP is required.' });
    } else if (otp.length !== 6) {
      validate = true;
      this.setState({ errors: 'OTP must be 6 digits.' });
    }

    return validate;
  };

  handleSendOTP = (e) => {
    e.preventDefault();
    if (!this.validateMobile()) {
      let { mobileNumber, countryCode } = this.state;
      this.setState({ loader: true, errors: '' });

      // Convert countryCode from string "+1" to number "1" (remove +)
      const countryCodeNum = countryCode.replace(/^\+/, '');
      
      let obj = {
        mobile: mobileNumber,
        countryCode: parseInt(countryCodeNum, 10),
        smsType: "forgetPassword",
        isAdmin: true,
      };

      let { dispatch } = this.props;
      dispatch(usersActions.sendDeleteAccountOTP(obj)).then(data => {
        this.setState({ loader: false });

        if (data.statusCode == 1) {
          this.setState({
            otpSent: true,
            success: data.responseData.message || 'OTP sent to your mobile number.'
          });
          this.startOTPTimer();
          notify('success', data.responseData.message || 'OTP sent successfully');
        } else {
          this.setState({
            errors: data.error.responseMessage || 'Failed to send OTP. Please try again.'
          });
          notify('error', data.error.responseMessage || 'Failed to send OTP');
        }
      }).catch(err => {
        this.setState({
          loader: false,
          errors: err.error?.responseMessage || 'Failed to send OTP. Please try again.'
        });
        notify('error', err.error?.responseMessage || 'Failed to send OTP');
      });
    }
  };

  handleDeleteAccount = (e) => {
    e.preventDefault();
    if (!this.validateOTP()) {
      let { mobileNumber, countryCode, otp } = this.state;
      this.setState({ loader: true, errors: '' });

      // Convert countryCode from string "+1" to number "1" (remove +)
      const countryCodeNum = countryCode.replace(/^\+/, '');

      // Step 1: Verify OTP
      let verifyOtpObj = {
        mobile: mobileNumber,
        countryCode: parseInt(countryCodeNum, 10),
        otp: otp
      };

      let { dispatch } = this.props;
      dispatch(usersActions.verifyOtp(verifyOtpObj)).then(data => {
        if (data.statusCode == 1) {
          // Step 2: Get auth token and userId from verify OTP response
          const responseData = data.responseData || {};
          const authToken = responseData.accessToken;
          const userId = responseData.userProfile?.userId || responseData.userProfile?._id;

          if (!authToken) {
            this.setState({
              loader: false,
              errors: 'Failed to get authentication token from OTP verification. Please try again.'
            });
            notify('error', 'Failed to get authentication token');
            return Promise.reject(new Error('Missing auth token'));
          }

          if (!userId) {
            this.setState({
              loader: false,
              errors: 'Failed to get user ID from OTP verification. Please try again.'
            });
            notify('error', 'Failed to get user ID');
            return Promise.reject(new Error('Missing user ID'));
          }

          // Store token and userId
          this.setState({ authToken, userId });

          // Step 3: Call delete user API with userId and accessToken
          let deleteUserObj = {
            userId: userId,
            accessToken: authToken
          };

          return dispatch(usersActions.deleteAccountWithOTP(deleteUserObj));
        } else {
          const errorMessage = data.error?.responseMessage || 'OTP verification failed. Please try again.';
          this.setState({
            loader: false,
            errors: errorMessage
          });
          notify('error', errorMessage);
          return Promise.reject(new Error('OTP verification failed'));
        }
      }).then(data => {
        if (data && data.statusCode == 1) {
          this.setState({
            loader: false,
            success: true,
            otp: ''
          });
          notify('success', data.responseData?.message || 'Your account has been deleted successfully.');
          
          // Redirect to same page (delete-account page)
          setTimeout(() => {
            window.location.href = '/delete-account';
          }, 3000);
        } else if (data) {
          this.setState({
            loader: false,
            errors: data.error?.responseMessage || 'Failed to delete account. Please try again.'
          });
          notify('error', data.error?.responseMessage || 'Failed to delete account');
        }
      }).catch(err => {
        // Check if error is from verify OTP failure (already handled above)
        if (err.message === 'OTP verification failed' || err.message === 'Missing auth token' || err.message === 'Missing user ID') {
          // Already handled in the then block, just stop here - don't show duplicate toast
          return;
        }
        
        // For other errors, show toast
        this.setState({
          loader: false,
          errors: err.error?.responseMessage || err.message || 'Failed to delete account. Please try again.'
        });
        
        // Only show toast if we have an error message that wasn't already shown
        if (err.error?.responseMessage) {
          notify('error', err.error.responseMessage);
        } else if (err.message && err.message !== 'OTP verification failed') {
          notify('error', err.message);
        }
      });
    }
  };

  render() {
    let { mobileNumber, countryCode, otp, errors, success, otpSent, loader, otpTimer, canResendOTP } = this.state;

    return (
      <div className="delete-account-page">
        {loader && <Loader />}
          <Row className="delete-account-wrapper">
            <Col lg={6} className="delete-account-info">
              <div className="info-content">
                <div className="logo-section">
                  <img
                    src={require('../../assets/img/DDlogo.png')}
                    alt="Date Dish Logo"
                    className="info-logo"
                  />
                </div>
                <div className="greeting">
                  <h2>Hello!</h2>
                </div>
                <div className="privacy-statement">
                  <p>
                    We respect your right to privacy and offer you the option to exercise your right to be forgotten. 
                    If you wish to have your personal data removed from our system, please enter your mobile number. 
                    Upon submission, you will receive an OTP to confirm your request.
                  </p>
                </div>
                <div className="instructions">
                  <ol>
                    <li>Enter your mobile number in the field below.</li>
                    <li>Click the "Send OTP" button.</li>
                    <li>Check your mobile for an OTP from DateDish.</li>
                    <li>Enter the OTP in the verification field.</li>
                    <li>
                      Once verified, the following data will be permanently deleted:
                      <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Profile information (name, bio, photos, preferences)</li>
                        <li>Messages, chats, likes, and interactions</li>
                        <li>Activity history and notifications</li>
                      </ul>
                      <strong>Note:</strong> Financial records (payments/subscriptions) may be retained for legal and audit purposes only.
                    </li>
                  </ol>
                </div>
              </div>
            </Col>
            <Col lg={6} className="delete-account-form-col">
              <div className="form-wrapper">
                <h3 className="form-title">Delete Account Request</h3>
                
                <Form onSubmit={otpSent ? this.handleDeleteAccount : this.handleSendOTP}>
                  {!otpSent ? (
                    <>
                      <Form.Group className="form-group-custom">
                        <div className="d-flex">
                          <Form.Control
                            as="select"
                            name="countryCode"
                            value={countryCode}
                            onChange={this.handleOnChange}
                            className="form-control-custom"
                            style={{ width: '60px', marginRight: '10px', flexShrink: 0, paddingLeft: '8px', paddingRight: '8px' }}
                          >
                            <option value="+1">+1</option>
                            <option value="+91">+91</option>
                          </Form.Control>
                          <Form.Control
                            type="tel"
                            name="mobileNumber"
                            value={mobileNumber}
                            onChange={this.handleOnChange}
                            placeholder="Enter Mobile Number"
                            className="form-control-custom"
                            maxLength="10"
                            pattern="[0-9]*"
                            style={{ flex: 1 }}
                          />
                        </div>
                      </Form.Group>
                      <Button
                        type="submit"
                        className="submit-btn textboxcol"
                        disabled={loader || !this.isMobileValid()}
                      >
                        Send OTP
                      </Button>
                    </>
                  ) : (
                    <>
                      <div className="otp-info-text">
                        <p>We've sent a 6-digit OTP to your mobile number <strong>{countryCode} {mobileNumber}</strong>. Please enter it below to confirm account deletion.</p>
                      </div>
                      <Form.Group className="form-group-custom">
                        <Form.Control
                          type="text"
                          name="otp"
                          value={otp}
                          onChange={this.handleOnChange}
                          placeholder="Enter OTP"
                          className="form-control-custom"
                          maxLength="6"
                          pattern="[0-9]*"
                        />
                        <div style={{ 
                          marginTop: '8px', 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center' 
                        }}>
                          {this.state.otpTimer > 0 ? (
                            <div className="otp-timer" style={{ fontSize: '14px', color: '#6c757d' }}>
                              OTP expires in: <strong>{this.formatTime(this.state.otpTimer)}</strong>
                            </div>
                          ) : (
                            <div></div>
                          )}
                          <Button
                            type="button"
                            variant="link"
                            onClick={this.handleResendOTP}
                            disabled={loader || !this.state.canResendOTP}
                            style={{
                              padding: 0,
                              color: this.state.canResendOTP ? '#007bff' : '#6c757d',
                              textDecoration: 'none',
                              fontSize: '14px',
                              cursor: this.state.canResendOTP && !loader ? 'pointer' : 'not-allowed',
                              opacity: this.state.canResendOTP ? 1 : 0.6,
                              width: 'fit-content',
                            }}
                            onMouseEnter={(e) => {
                              if (this.state.canResendOTP && !loader) {
                                e.currentTarget.style.textDecoration = 'underline';
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.textDecoration = 'none';
                            }}
                          >
                            Resend OTP
                          </Button>
                        </div>
                      </Form.Group>
                      <div className="d-flex align-items-center gap-4">
                        <Button
                          type="submit"
                          variant="danger"
                          className="submit-btn delete-btn mb-0"
                          disabled={loader || !this.isOtpValid()}
                        >
                          Delete Account
                        </Button>
                        <Button
                          type="button"
                          variant="outline-secondary"
                          className="cancel-btn"
                          onClick={() => {
                            if (this.timerInterval) {
                              clearInterval(this.timerInterval);
                            }
                            this.setState({ otpSent: false, otp: '', errors: '', otpTimer: 0, canResendOTP: false });
                          }}
                          disabled={loader}
                          style={{
                            color: '#6c757d',
                            borderColor: '#6c757d'
                          }}
                          onMouseEnter={(e) => {
                            const btn = e.currentTarget;
                            btn.style.color = '#6c757d';
                            btn.style.backgroundColor = '#e9ecef';
                          }}
                          onMouseLeave={(e) => {
                            const btn = e.currentTarget;
                            btn.style.color = '#6c757d';
                            btn.style.backgroundColor = 'transparent';
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { props, login, user } = state;
  return {
    props,
    login,
    user
  };
}

export default connect(mapStateToProps)(DeleteAccount);

